import React from 'react'
import Logo from '../../componetns/logo'
import Contact from '../../componetns/contact'
import MobileHeader from './mobileHeader'
import { Link } from 'react-router-dom'
import BackButton from "../img/back-button.png"
import LogoDarkAnimator from '../../componetns/logoDarkAnimator'
const MobileContact = () => {
    return (
        <div>
            <div className="Mobile_header">
                <Link to="/" className=" mobile_back" style={{ border: 'none', marginTop: '.5rem', marginLeft: '.5rem' }} >
                    <img src={BackButton} alt="" />
                </Link>
                {/* <img src={LogoMain} alt="logo" /> */}
                <Link to="/">
                    <LogoDarkAnimator />
                </Link>
                <div className=""></div>
            </div>
            <div className="p-3 mobile_about">
                <Contact />
            </div>

        </div>
    )
}

export default MobileContact